import ContactState from '../contact/contact.state';
import ContactsTypes from './contacts.types';

export type ContactsAction =
    | { type: typeof ContactsTypes.ADD_CONTACT; payload: ContactState; }
    | { type: typeof ContactsTypes.FILTER_CONTACTS; payload: string; }


export function addContact(contact: ContactState): ContactsAction {
    return {
        type: ContactsTypes.ADD_CONTACT,
        payload: contact,
    };
}

export function filterContacts(contactID: string): ContactsAction {
    return {
        type: ContactsTypes.FILTER_CONTACTS,
        payload: contactID,
    };
}